import editCashInstrumentsReducer from '../state/edit-cash-instruments-slice'

export const cashInstrumentsReducer = {
  editCashInstruments: editCashInstrumentsReducer
}
